// Efeitos das notificações de SOLICITAÇÃO DE ACESSO.
// Registrado em `constants/notificationHandlers.ts`.

import type { HandlerPorPrefixo } from '../../constants/notificationHandlers';

/**
 * Família por PREFIXO, não por tipo exato — é assim desde sempre
 * (`message.type.startsWith('solicitacao_acesso_')` no provider antigo) porque
 * o backend emite variações (`_criada`, `_aprovada`, `_negada`, ...) e todas
 * mexem exatamente nas mesmas três listas.
 */
export const HANDLERS_SOLICITACAO_ACESSO_POR_PREFIXO: HandlerPorPrefixo[] = [
  {
    prefixo: 'solicitacao_acesso_',
    handler: ({ queryClient }) => {
      queryClient.invalidateQueries({ queryKey: ['solicitacoes-pendentes'] });
      queryClient.invalidateQueries({ queryKey: ['solicitacoes-recebidas'] });
      queryClient.invalidateQueries({ queryKey: ['minhas-solicitacoes'] });
    },
  },
];
